var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGavel = function SvgGavel(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19h10q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 15 21H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 20q0-.424.287-.712A.97.97 0 0 1 5 19m3.225-4.275L5.4 11.9a1.96 1.96 0 0 1-.588-1.412q-.012-.838.563-1.413L6.1 8.35 11.8 14l-.725.725q-.575.575-1.425.575t-1.425-.575M16 9.8l-5.65-5.7.725-.725q.574-.574 1.413-.562.837.012 1.412.587l2.825 2.825q.575.574.575 1.425 0 .85-.575 1.425zm3.9 9.5L7.55 6.95l1.4-1.4L21.3 17.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGavel);
export { ForwardRef as ReactComponent };